webpackJsonp([65],{

/***/ "4THJ":
/***/ (function(module, exports, __webpack_require__) {

var SubscriptionCurrentPlanContainer = (function () {
    function SubscriptionCurrentPlanContainer() {
    }
    return SubscriptionCurrentPlanContainer;
}());
angular.module('animatronApp.SubscriptionCurrentPlanContainer', [])
    .component('subscriptionCurrentPlanContainer', {
    controller: SubscriptionCurrentPlanContainer,
    templateUrl: __webpack_require__("TUYZ")
});


/***/ }),

/***/ "TUYZ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "html/subscription-current-plan-container_3abd2dbff6f454536342c52ca2403201.html";

/***/ })

});


// WEBPACK FOOTER //
// javascripts/65-c7c98a0cc108ea8b91f3.min.js